import client from '@/api/base/client';
import { errorHandler } from '@/api/base/errorHandler';

/**
 * Обработка запроса
 * @param requestParams
 * @param {String} requestParams.type тип запроса
 * @param {String} requestParams.url url запроса
 * @param {String | undefined} requestParams.target имя свойства в ответе, которое необходимо вернуть
 * @param {Boolean | undefined} requestParams.isSilent флаг отправки запроса в фоновом режиме (без отображения результата юзеру)
 * @param {Boolean | undefined} requestParams.isMultipart флаг отправки запроса с бинарными данными
 * @param {String | undefined} requestParams.fallbackErrorText текст ошибки по умолчанию, если она отсутствует в ответе сервера
 * @param {Object} requestData данные запроса
 * @returns {Promise<unknown>}
 */

export const requestHandler = (requestParams, requestData = {}, headers = {}) => {
    const isSilentMode = requestParams?.isSilent;
    const isMultipart = requestParams?.isMultipart;

    const requestConfig = { headers }

    if (isMultipart) {
        requestConfig.headers['Content-Type'] = 'multipart/form-data';
    }

    return new Promise((resolve, reject) => {
        client[requestParams.type](requestParams.url, requestData, requestConfig).then(data => {
            if (requestParams.target) resolve(data.data[requestParams.target])
            resolve(data)
        }).catch(error => {
            reject(error)
            if (!isSilentMode) {
                errorHandler(error, requestParams.fallbackErrorText);
            }
        });
    });
};
